export const ScreenInInitCallbackSymbol = Symbol('ScreenIn')

export const name = 'screenIn' as const

export const SCREEN_IN_CALLBACK = 'screenInCallback'
